import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SeparatedBars = function SeparatedBars(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: size * 1.4166,
    height: size,
    viewBox: "0 0 11 10",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0.666687",
      y: "5",
      width: "1.66667",
      height: "4.66667",
      rx: "0.833333",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("rect", {
      x: "5",
      y: "2.33334",
      width: "1.66667",
      height: "7.33333",
      rx: "0.833333",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("rect", {
      x: "9.33337",
      y: "0.333344",
      width: "1.66667",
      height: "9.33333",
      rx: "0.833333",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default SeparatedBars;